module.exports = __webpack_public_path__ + "img/第6章_1-1_往開化寺紙條.jpg";